import { render, staticRenderFns } from "./DoctorAcounting.vue?vue&type=template&id=6546a1bb&scoped=true"
import script from "./DoctorAcounting.vue?vue&type=script&lang=js"
export * from "./DoctorAcounting.vue?vue&type=script&lang=js"
import style0 from "./DoctorAcounting.vue?vue&type=style&index=0&id=6546a1bb&prod&scoped=true&lang=css"
import style1 from "./DoctorAcounting.vue?vue&type=style&index=1&id=6546a1bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6546a1bb",
  null
  
)

export default component.exports